import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";
import Link from "../components/Link";
import { graphql } from "gatsby";

const useStyles = makeStyles({
  mainRoot: {
    background: "#09333F",
    backgroundSize: "100% 100%",
    animation: "$gradient 8s ease infinite",
    color: "#fff",
  },
  "@keyframes gradient": {
    "0%": {
      backgroundPosition: "0% 50%",
    },
    "50%": {
      backgroundPosition: "100% 50%",
    },
    "100%": {
      backgroundPosition: "0% 50%",
    },
  },
  root: {
    marginTop: "2rem",
    marginBottom: "2rem",
  },
  marginBottom: {
    marginBottom: "2rem",
  },
  marginBottomBold: {
    marginBottom: "2rem",
    fontWeight: "bold",
  },
  bold: {
    fontWeight: "bold",
    marginBottom: "1rem",
  },
  link: {
    color: "#abcdee",
    cursor: "pointer",
  },
  gridTypo: {
    paddingRight: "1rem",
    paddingLeft: "1rem",
  },
});

export default function Datenschutz() {
  const classes = useStyles();

  return (
    <div className={classes.mainRoot}>
      <Navbar />

      <Grid container className={classes.root}>
        <Grid item xs={1} sm={2} md={2} />
        <Grid item xs={12} md={8} className={classes.gridTypo}>
          <Typography variant="h5" className={classes.marginBottomBold}>
            Datenschutzerklärung
          </Typography>
          <Typography variant="body1" className={classes.marginBottom}>
            Stand: 29.05.2026
          </Typography>

          {/* 1. Datenschutz auf einen Blick */}
          <Typography variant="h5" className={classes.bold}>
            1. Datenschutz auf einen Blick
          </Typography>

          <Typography variant="h6" className={classes.bold}>
            Allgemeine Hinweise
          </Typography>
          <Typography variant="body1" className={classes.marginBottom}>
            Die folgenden Hinweise geben einen einfachen Überblick darüber, was
            mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website
            besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie
            persönlich identifiziert werden können. Ausführliche Informationen
            zum Thema Datenschutz entnehmen Sie unserer unter diesem Text
            aufgeführten Datenschutzerklärung.
          </Typography>

          <Typography variant="h6" className={classes.bold}>
            Datenerfassung auf dieser Website
          </Typography>

          <Typography variant="body1" className={classes.marginBottom}>
            <strong>
              Wer ist verantwortlich für die Datenerfassung auf dieser Website?
            </strong>
            <br />
            Die Datenverarbeitung auf dieser Website erfolgt durch den
            Websitebetreiber. Dessen Kontaktdaten können Sie dem Abschnitt
            „Hinweis zur Verantwortlichen Stelle“ in dieser Datenschutzerklärung
            entnehmen.
            <br />
            <br />
            <strong>Wie erfassen wir Ihre Daten?</strong>
            <br />
            Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese
            mitteilen. Hierbei kann es sich z. B. um Daten handeln, die Sie in
            ein Kontaktformular eingeben.
            <br />
            Andere Daten werden automatisch oder nach Ihrer Einwilligung beim
            Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor
            allem technische Daten (z. B. Internetbrowser, Betriebssystem oder
            Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt
            automatisch, sobald Sie diese Website betreten.
            <br />
            <br />
            <strong>Wofür nutzen wir Ihre Daten?</strong>
            <br />
            Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung
            der Website zu gewährleisten. Andere Daten können zur Analyse Ihres
            Nutzerverhaltens verwendet werden.
            <br />
            <br />
            <strong>Welche Rechte haben Sie bezüglich Ihrer Daten?</strong>
            <br />
            Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft,
            Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu
            erhalten. Sie haben außerdem ein Recht, die Berichtigung oder
            Löschung dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur
            Datenverarbeitung erteilt haben, können Sie diese Einwilligung
            jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht,
            unter bestimmten Umständen die Einschränkung der Verarbeitung Ihrer
            personenbezogenen Daten zu verlangen. Des Weiteren steht Ihnen ein
            Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
            <br />
            Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie
            sich jederzeit an uns wenden.
          </Typography>

          {/* 2. Hosting */}
          <Typography variant="h5" className={classes.bold}>
            2. Hosting
          </Typography>

          <Typography variant="body1" className={classes.marginBottom}>
            Wir hosten die Inhalte unserer Website bei folgendem Anbieter:
          </Typography>

          <Typography variant="h6" className={classes.bold}>
            Externes Hosting
          </Typography>

          <Typography variant="body1" className={classes.marginBottom}>
            Diese Website wird extern gehostet. Die personenbezogenen Daten, die
            auf dieser Website erfasst werden, werden auf den Servern des
            Hosters / der Hoster gespeichert. Hierbei kann es sich v. a. um
            IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten,
            Vertragsdaten, Kontaktdaten, Namen, Websitezugriffe und sonstige
            Daten, die über eine Website generiert werden, handeln.
            <br />
            <br />
            Das externe Hosting erfolgt zum Zwecke der Vertragserfüllung
            gegenüber unseren potenziellen und bestehenden Kunden (Art. 6 Abs. 1
            lit. b DSGVO) und im Interesse einer sicheren, schnellen und
            effizienten Bereitstellung unseres Online-Angebots durch einen
            professionellen Anbieter (Art. 6 Abs. 1 lit. f DSGVO). Sofern eine
            entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung
            ausschließlich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und § 25
            Abs. 1 TDDDG, soweit die Einwilligung die Speicherung von Cookies
            oder den Zugriff auf Informationen im Endgerät des Nutzers (z. B.
            Device-Fingerprinting) im Sinne des TDDDG umfasst. Die Einwilligung
            ist jederzeit widerrufbar.
            <br />
            <br />
            Unser(e) Hoster wird bzw. werden Ihre Daten nur insoweit
            verarbeiten, wie dies zur Erfüllung seiner Leistungspflichten
            erforderlich ist und unsere Weisungen in Bezug auf diese Daten
            befolgen.
            <br />
            <br />
            Wir setzen folgende(n) Hoster ein:
            <br />
            <br />
            Vercel Inc.
            <br />
            340 S Lemon Ave #4133
            <br />
            Walnut, California 91789
            <br />
            United States
            <br />
            ar@vercel.com
          </Typography>

          <Typography variant="h6" className={classes.bold}>
            Auftragsverarbeitung
          </Typography>
          <Typography variant="body1" className={classes.marginBottom}>
            Wir haben einen Vertrag über Auftragsverarbeitung (AVV) zur Nutzung
            des oben genannten Dienstes geschlossen. Hierbei handelt es sich um
            einen datenschutzrechtlich vorgeschriebenen Vertrag, der
            gewährleistet, dass dieser die personenbezogenen Daten unserer
            Websitebesucher nur nach unseren Weisungen und unter Einhaltung der
            DSGVO verarbeitet.
          </Typography>

          {/* 3. Allgemeine Hinweise und Pflichtinformationen */}
          <Typography variant="h5" className={classes.bold}>
            3. Allgemeine Hinweise und Pflicht­informationen
          </Typography>

          <Typography variant="h6" className={classes.bold}>
            Datenschutz
          </Typography>
          <Typography variant="body1" className={classes.marginBottom}>
            Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen
            Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten
            vertraulich und entsprechend den gesetzlichen
            Datenschutzvorschriften sowie dieser Datenschutzerklärung.
            <br />
            Wenn Sie diese Website benutzen, werden verschiedene
            personenbezogene Daten erhoben. Personenbezogene Daten sind Daten,
            mit denen Sie persönlich identifiziert werden können. Die
            vorliegende Datenschutzerklärung erläutert, welche Daten wir erheben
            und wofür wir sie nutzen. Sie erläutert auch, wie und zu welchem
            Zweck das geschieht.
            <br />
            Wir weisen darauf hin, dass die Datenübertragung im Internet (z. B.
            bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann.
            Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist
            nicht möglich.
          </Typography>

          <Typography variant="h6" className={classes.bold}>
            Hinweis zur verantwortlichen Stelle
          </Typography>
          <Typography variant="body1" className={classes.marginBottom}>
            Die verantwortliche Stelle für die Datenverarbeitung auf dieser
            Website ist:
            <br />
            M3E GmbH
            <br />
            Immanuelkirchstrasse 12
            <br />
            10405 Berlin
            <br />
            Registergericht: Amtsgericht Charlottenburg HRB 70275
            <br />
            Geschäftsführer: Dr. Christian Milan
            <br />
            Telefon: 030/403672121
            <br />
            E-Mail: info@m3e-gmbh.com
            <br />
            <br />
            Verantwortliche Stelle ist die natürliche oder juristische Person,
            die allein oder gemeinsam mit anderen über die Zwecke und Mittel der
            Verarbeitung von personenbezogenen Daten (z. B. Namen,
            E-Mail-Adressen o. Ä.) entscheidet.
          </Typography>

          <Typography variant="h6" className={classes.bold}>
            Speicherdauer
          </Typography>
          <Typography variant="body1" className={classes.marginBottom}>
            Soweit innerhalb dieser Datenschutzerklärung keine speziellere
            Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen Daten
            bei uns, bis der Zweck für die Datenverarbeitung entfällt. Wenn Sie
            ein berechtigtes Löschersuchen geltend machen oder eine Einwilligung
            zur Datenverarbeitung widerrufen, werden Ihre Daten gelöscht, sofern
            wir keine anderen rechtlich zulässigen Gründe für die Speicherung
            Ihrer personenbezogenen Daten haben (z. B. steuer- oder
            handelsrechtliche Aufbewahrungsfristen); im letztgenannten Fall
            erfolgt die Löschung nach Fortfall dieser Gründe.
          </Typography>

          <Typography variant="h6" className={classes.bold}>
            Allgemeine Hinweise zu den Rechtsgrundlagen der Datenverarbeitung
            auf dieser Website
          </Typography>
          <Typography variant="body1" className={classes.marginBottom}>
            Sofern Sie in die Datenverarbeitung eingewilligt haben, verarbeiten
            wir Ihre personenbezogenen Daten auf Grundlage von Art. 6 Abs. 1
            lit. a DSGVO bzw. Art. 9 Abs. 2 lit. a DSGVO, sofern besondere
            Datenkategorien nach Art. 9 Abs. 1 DSGVO verarbeitet werden. Im
            Falle einer ausdrücklichen Einwilligung in die Übertragung
            personenbezogener Daten in Drittstaaten erfolgt die
            Datenverarbeitung außerdem auf Grundlage von Art. 49 Abs. 1 lit. a
            DSGVO. Sofern Sie in die Speicherung von Cookies oder in den Zugriff
            auf Informationen in Ihr Endgerät (z. B. via Device-Fingerprinting)
            eingewilligt haben, erfolgt die Datenverarbeitung zusätzlich auf
            Grundlage von § 25 Abs. 1 TDDDG. Die Einwilligung ist jederzeit
            widerrufbar. Sind Ihre Daten zur Vertragserfüllung oder zur
            Durchführung vorvertraglicher Maßnahmen erforderlich, verarbeiten
            wir Ihre Daten auf Grundlage des Art. 6 Abs. 1 lit. b DSGVO. Des
            Weiteren verarbeiten wir Ihre Daten, sofern diese zur Erfüllung
            einer rechtlichen Verpflichtung erforderlich sind auf Grundlage von
            Art. 6 Abs. 1 lit. c DSGVO. Die Datenverarbeitung kann ferner auf
            Grundlage unseres berechtigten Interesses nach Art. 6 Abs. 1 lit. f
            DSGVO erfolgen. Über die jeweils im Einzelfall einschlägigen
            Rechtsgrundlagen wird in den folgenden Absätzen dieser
            Datenschutzerklärung informiert.
          </Typography>

          <Typography variant="h6" className={classes.bold}>
            Datenschutz­beauftragter
          </Typography>
          <Typography variant="body1" className={classes.marginBottom}>
            Wir haben einen Datenschutzbeauftragten benannt.
            <br />
            Complimate GmbH
            <br />
            Edisonstraße 2
            <br />
            87437 Kempten
            <br />
            Telefon: +4983156400500
            <br />
            E-Mail: support@complimate.de
          </Typography>

          <Typography variant="h6" className={classes.bold}>
            Hinweis zur Datenweitergabe in die USA und sonstige Drittstaaten
          </Typography>
          <Typography variant="body1" className={classes.marginBottom}>
            Wir verwenden unter anderem Tools von Unternehmen mit Sitz in den
            USA oder sonstigen datenschutzrechtlich nicht sicheren Drittstaaten.
            Wenn diese Tools aktiv sind, können Ihre personenbezogene Daten in
            diese Drittstaaten übertragen und dort verarbeitet werden. Wir
            weisen darauf hin, dass in diesen Ländern kein mit der EU
            vergleichbares Datenschutzniveau garantiert werden kann.
            Beispielsweise sind US-Unternehmen dazu verpflichtet,
            personenbezogene Daten an Sicherheitsbehörden herauszugeben, ohne
            dass Sie als Betroffener hiergegen gerichtlich vorgehen könnten. Es
            kann daher nicht ausgeschlossen werden, dass US-Behörden (z. B.
            Geheimdienste) Ihre auf US-Servern befindlichen Daten zu
            Überwachungszwecken verarbeiten, auswerten und dauerhaft speichern.
            Wir haben auf diese Verarbeitungstätigkeiten keinen Einfluss.
          </Typography>

          <Typography variant="h6" className={classes.bold}>
            Widerruf Ihrer Einwilligung zur Datenverarbeitung
          </Typography>
          <Typography variant="body1" className={classes.marginBottom}>
            Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen
            Einwilligung möglich. Sie können eine bereits erteilte Einwilligung
            jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf
            erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.
          </Typography>

          <Typography variant="h6" className={classes.bold}>
            Widerspruchsrecht gegen die Datenerhebung in besonderen Fällen sowie
            gegen Direktwerbung (Art. 21 DSGVO)
          </Typography>
          <Typography variant="body1" className={classes.marginBottom}>
            WENN DIE DATENVERARBEITUNG AUF GRUNDLAGE VON ART. 6 ABS. 1 LIT. E
            ODER F DSGVO ERFOLGT, HABEN SIE JEDERZEIT DAS RECHT, AUS GRÜNDEN,
            DIE SICH AUS IHRER BESONDEREN SITUATION ERGEBEN, GEGEN DIE
            VERARBEITUNG IHRER PERSONENBEZOGENEN DATEN WIDERSPRUCH EINZULEGEN;
            DIES GILT AUCH FÜR EIN AUF DIESE BESTIMMUNGEN GESTÜTZTES PROFILING.
            DIE JEWEILIGE RECHTSGRUNDLAGE, AUF DENEN EINE VERARBEITUNG BERUHT,
            ENTNEHMEN SIE DIESER DATENSCHUTZERKLÄRUNG. WENN SIE WIDERSPRUCH
            EINLEGEN, WERDEN WIR IHRE BETROFFENEN PERSONENBEZOGENEN DATEN NICHT
            MEHR VERARBEITEN, ES SEI DENN, WIR KÖNNEN ZWINGENDE SCHUTZWÜRDIGE
            GRÜNDE FÜR DIE VERARBEITUNG NACHWEISEN, DIE IHRE INTERESSEN, RECHTE
            UND FREIHEITEN ÜBERWIEGEN ODER DIE VERARBEITUNG DIENT DER
            GELTENDMACHUNG, AUSÜBUNG ODER VERTEIDIGUNG VON RECHTSANSPRÜCHEN
            (WIDERSPRUCH NACH ART. 21 ABS. 1 DSGVO).
            <br />
            <br />
            WERDEN IHRE PERSONENBEZOGENEN DATEN VERARBEITET, UM DIREKTWERBUNG ZU
            BETREIBEN, SO HABEN SIE DAS RECHT, JEDERZEIT WIDERSPRUCH GEGEN DIE
            VERARBEITUNG SIE BETREFFENDER PERSONENBEZOGENER DATEN ZUM ZWECKE
            DERARTIGER WERBUNG EINZULEGEN; DIES GILT AUCH FÜR DAS PROFILING,
            SOWEIT ES MIT SOLCHER DIREKTWERBUNG IN VERBINDUNG STEHT. WENN SIE
            WIDERSPRECHEN, WERDEN IHRE PERSONENBEZOGENEN DATEN ANSCHLIESSEND
            NICHT MEHR ZUM ZWECKE DER DIREKTWERBUNG VERWENDET (WIDERSPRUCH NACH
            ART. 21 ABS. 2 DSGVO).
          </Typography>

          <Typography variant="h6" className={classes.bold}>
            Beschwerde­recht bei der zuständigen Aufsichts­behörde
          </Typography>
          <Typography variant="body1" className={classes.marginBottom}>
            Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein
            Beschwerderecht bei einer Aufsichtsbehörde, insbesondere in dem
            Mitgliedstaat ihres gewöhnlichen Aufenthalts, ihres Arbeitsplatzes
            oder des Orts des mutmaßlichen Verstoßes zu. Das Beschwerderecht
            besteht unbeschadet anderweitiger verwaltungsrechtlicher oder
            gerichtlicher Rechtsbehelfe.
          </Typography>

          <Typography variant="h6" className={classes.bold}>
            Recht auf Daten­übertrag­barkeit
          </Typography>
          <Typography variant="body1" className={classes.marginBottom}>
            Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung
            oder in Erfüllung eines Vertrags automatisiert verarbeiten, an sich
            oder an einen Dritten in einem gängigen, maschinenlesbaren Format
            aushändigen zu lassen. Sofern Sie die direkte Übertragung der Daten
            an einen anderen Verantwortlichen verlangen, erfolgt dies nur,
            soweit es technisch machbar ist.
          </Typography>

          <Typography variant="h6" className={classes.bold}>
            Auskunft, Berichtigung und Löschung
          </Typography>
          <Typography variant="body1" className={classes.marginBottom}>
            Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen
            jederzeit das Recht auf unentgeltliche Auskunft über Ihre
            gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger
            und den Zweck der Datenverarbeitung und ggf. ein Recht auf
            Berichtigung oder Löschung dieser Daten. Hierzu sowie zu weiteren
            Fragen zum Thema personenbezogene Daten können Sie sich jederzeit an
            uns wenden.
          </Typography>

          <Typography variant="h6" className={classes.bold}>
            Recht auf Einschränkung der Verarbeitung
          </Typography>
          <Typography variant="body1" className={classes.marginBottom}>
            Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer
            personenbezogenen Daten zu verlangen. Hierzu können Sie sich
            jederzeit an uns wenden. Das Recht auf Einschränkung der
            Verarbeitung besteht in folgenden Fällen:
            <br />
            - Wenn Sie die Richtigkeit Ihrer bei uns gespeicherten
            personenbezogenen Daten bestreiten, benötigen wir in der Regel Zeit,
            um dies zu überprüfen. Für die Dauer der Prüfung haben Sie das
            Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen
            Daten zu verlangen.
            <br />
            - Wenn die Verarbeitung Ihrer personenbezogenen Daten unrechtmäßig
            geschah/geschieht, können Sie statt der Löschung die Einschränkung
            der Datenverarbeitung verlangen.
            <br />
            - Wenn wir Ihre personenbezogenen Daten nicht mehr benötigen, Sie
            sie jedoch zur Ausübung, Verteidigung oder Geltendmachung von
            Rechtsansprüchen benötigen, haben Sie das Recht, statt der Löschung
            die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu
            verlangen.
            <br />
            - Wenn Sie einen Widerspruch nach Art. 21 Abs. 1 DSGVO eingelegt
            haben, muss eine Abwägung zwischen Ihren und unseren Interessen
            vorgenommen werden. Solange noch nicht feststeht, wessen Interessen
            überwiegen, haben Sie das Recht, die Einschränkung der Verarbeitung
            Ihrer personenbezogenen Daten zu verlangen.
            <br />
            <br />
            Wenn Sie die Verarbeitung Ihrer personenbezogenen Daten
            eingeschränkt haben, dürfen diese Daten – von ihrer Speicherung
            abgesehen – nur mit Ihrer Einwilligung oder zur Geltendmachung,
            Ausübung oder Verteidigung von Rechtsansprüchen oder zum Schutz der
            Rechte einer anderen natürlichen oder juristischen Person oder aus
            Gründen eines wichtigen öffentlichen Interesses der Europäischen
            Union oder eines Mitgliedstaats verarbeitet werden.
          </Typography>

          <Typography variant="h6" className={classes.bold}>
            SSL- bzw. TLS-Verschlüsselung
          </Typography>
          <Typography variant="body1" className={classes.marginBottom}>
            Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der
            Übertragung vertraulicher Inhalte, wie zum Beispiel Bestellungen
            oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL-
            bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen
            Sie daran, dass die Adresszeile des Browsers von „http://“ auf
            „https://“ wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
            <br />
            Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die
            Daten, die Sie an uns übermitteln, nicht von Dritten mitgelesen
            werden.
          </Typography>

          {/* 4. Datenerfassung */}
          <Typography variant="h5" className={classes.bold}>
            4. Datenerfassung auf dieser Website
          </Typography>

          <Typography variant="h6" className={classes.bold}>
            Einwilligung mit Cookiebot
          </Typography>
          <Typography variant="body1" className={classes.marginBottom}>
            Unsere Website nutzt die Consent-Technologie von Cookiebot, um Ihre
            Einwilligung zur Speicherung bestimmter Cookies auf Ihrem Endgerät
            oder zum Einsatz bestimmter Technologien einzuholen und diese
            datenschutzkonform zu dokumentieren. Anbieter dieser Technologie ist
            Cybot A/S, Havnegade 39, 1058 Kopenhagen, Dänemark (im Folgenden
            „Cookiebot“).
            <br />
            Wenn Sie unsere Website betreten, wird eine Verbindung zu den
            Servern von Cookiebot hergestellt, um Ihre Einwilligungen und
            sonstigen Erklärungen zur Cookie-Nutzung einzuholen. Anschließend
            speichert Cookiebot einen Cookie in Ihrem Browser, um Ihnen die
            erteilten Einwilligungen bzw. deren Widerruf zuordnen zu können. Die
            so erfassten Daten werden gespeichert, bis Sie uns zur Löschung
            auffordern, den Cookiebot-Cookie selbst löschen oder der Zweck für
            die Datenspeicherung entfällt. Zwingende gesetzliche
            Aufbewahrungspflichten bleiben unberührt.
            <br />
            Der Einsatz von Cookiebot erfolgt, um die gesetzlich
            vorgeschriebenen Einwilligungen für den Einsatz von Cookies
            einzuholen. Rechtsgrundlage hierfür ist Art. 6 Abs. 1 lit. c DSGVO.
          </Typography>

          {/* 5. Soziale Medien */}
          <Typography variant="h5" className={classes.bold}>
            5. Soziale Medien
          </Typography>

          <Typography variant="h6" className={classes.bold}>
            LinkedIn
          </Typography>
          <Typography variant="body1" className={classes.marginBottom}>
            Diese Website nutzt Elemente des Netzwerks LinkedIn. Anbieter ist
            die LinkedIn Ireland Unlimited Company, Wilton Plaza, Wilton Place,
            Dublin 2, Irland.
            <br />
            Bei jedem Abruf einer Seite dieser Website, die Elemente von
            LinkedIn enthält, wird eine Verbindung zu Servern von LinkedIn
            aufgebaut. LinkedIn wird darüber informiert, dass Sie diese Website
            mit Ihrer IP-Adresse besucht haben. Wenn Sie den „Recommend-Button“
            von LinkedIn anklicken und in Ihrem Account bei LinkedIn eingeloggt
            sind, ist es LinkedIn möglich, Ihren Besuch auf dieser Website Ihnen
            und Ihrem Benutzerkonto zuzuordnen. Wir weisen darauf hin, dass wir
            als Anbieter der Seiten keine Kenntnis vom Inhalt der übermittelten
            Daten sowie deren Nutzung durch LinkedIn haben.
            <br />
            Soweit eine Einwilligung (Consent) eingeholt wurde, erfolgt der
            Einsatz des o. g. Dienstes auf Grundlage von Art. 6 Abs. 1 lit. a
            DSGVO und § 25 TDDDG. Die Einwilligung ist jederzeit widerrufbar.
            Soweit keine Einwilligung eingeholt wurde, erfolgt die Verwendung
            des Dienstes auf Grundlage unseres berechtigten Interesses an einer
            möglichst umfassenden Sichtbarkeit in den Sozialen Medien.
            <br />
            Die Datenübertragung in die USA wird auf die
            Standardvertragsklauseln der EU-Kommission gestützt. Details finden
            Sie hier:{" "}
            <Link
              href="https://www.linkedin.com/help/linkedin/answer/62538/datenubertragung-aus-der-eu-dem-ewr-und-der-schweiz?lang=de"
              external
              className={classes.link}
            >
              https://www.linkedin.com/help/linkedin/answer/62538/datenubertragung-aus-der-eu-dem-ewr-und-der-schweiz?lang=de
            </Link>
            <br />
            Weitere Informationen hierzu finden Sie in der Datenschutzerklärung
            von LinkedIn unter:{" "}
            <Link
              href="https://www.linkedin.com/legal/privacy-policy"
              external
              className={classes.link}
            >
              https://www.linkedin.com/legal/privacy-policy
            </Link>
            .
          </Typography>

          {/* 6. Analyse-Tools und Werbung */}
          <Typography variant="h5" className={classes.bold}>
            6. Analyse-Tools und Werbung
          </Typography>

          <Typography variant="h6" className={classes.bold}>
            Google Tag Manager
          </Typography>
          <Typography variant="body1" className={classes.marginBottom}>
            Wir setzen den Google Tag Manager ein. Anbieter ist die Google
            Ireland Limited, Gordon House, BarrowStreet, Dublin 4, Irland. Der
            Google Tag Manager ist ein Tool, mit dessen Hilfe wir Tracking- oder
            Statistik-Tools und andere Technologien auf unserer Website
            einbinden können. Der Google Tag Manager selbst erstellt keine
            Nutzerprofile, speichert keine Cookies und nimmt keine
            eigenständigen Analysen vor. Er dient lediglich der Verwaltung und
            Ausspielung der über ihn eingebundenen Tools. Der Google Tag Manager
            erfasst jedoch Ihre IP-Adresse, die auch an das Mutterunternehmen
            von Google in die Vereinigten Staaten übertragen werden kann.
            <br />
            <br />
            Der Einsatz des Google Tag Managers erfolgt auf Grundlage von Art. 6
            Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes
            Interesse an einer schnellen und unkomplizierten Einbindung und
            Verwaltung verschiedener Tools auf seiner Website. Sofern eine
            entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung
            ausschließlich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und § 25
            Abs. 1 TDDDG, soweit die Einwilligung die Speicherung von Cookies
            oder den Zugriff auf Informationen im Endgerät des Nutzers (z. B.
            Device-Fingerprinting) im Sinne des TDDDG umfasst. Die Einwilligung
            ist jederzeit widerrufbar.
            <br />
            <br />
            Das Unternehmen verfügt über eine Zertifizierung nach dem „EU-US
            Data Privacy Framework“ (DPF). Der DPF ist ein Übereinkommen
            zwischen der Europäischen Union und den USA, der die Einhaltung
            europäischer Datenschutzstandards bei Datenverarbeitungen in den USA
            gewährleisten soll. Jedes nach dem DPF zertifizierte Unternehmen
            verpflichtet sich, diese Datenschutzstandards einzuhalten. Weitere
            Informationen hierzu erhalten Sie vom Anbieter unter folgendem Link:{" "}
            <Link
              href="https://www.dataprivacyframework.gov/participant/5780"
              external
              className={classes.link}
            >
              https://www.dataprivacyframework.gov/participant/5780
            </Link>
            .
          </Typography>

          {/* 7. Newsletter */}
          <Typography variant="h5" className={classes.bold}>
            7. Newsletter
          </Typography>

          <Typography variant="h6" className={classes.bold}>
            Newsletterdaten
          </Typography>
          <Typography variant="body1" className={classes.marginBottom}>
            Wenn Sie den auf der Website angebotenen Newsletter beziehen
            möchten, benötigen wir von Ihnen eine E-Mail-Adresse sowie
            Informationen, welche uns die Überprüfung gestatten, dass Sie der
            Inhaber der angegebenen E-Mail-Adresse sind und mit dem Empfang des
            Newsletters einverstanden sind. Weitere Daten werden nicht bzw. nur
            auf freiwilliger Basis erhoben. Diese Daten verwenden wir
            ausschließlich für den Versand der angeforderten Informationen und
            geben diese nicht an Dritte weiter.
            <br />
            <br />
            Die Verarbeitung der in das Newsletteranmeldeformular eingegebenen
            Daten erfolgt ausschließlich auf Grundlage Ihrer Einwilligung (Art.
            6 Abs. 1 lit. a DSGVO). Die erteilte Einwilligung zur Speicherung
            der Daten, der E-Mail-Adresse sowie deren Nutzung zum Versand des
            Newsletters können Sie jederzeit widerrufen, etwa über den
            „Austragen“-Link im Newsletter. Die Rechtmäßigkeit der bereits
            erfolgten Datenverarbeitungsvorgänge bleibt vom Widerruf unberührt.
            <br />
            <br />
            Die von Ihnen zum Zwecke des Newsletter-Bezugs bei uns hinterlegten
            Daten werden von uns bis zu Ihrer Austragung aus dem Newsletter bei
            uns bzw. dem Newsletterdiensteanbieter gespeichert und nach der
            Abbestellung des Newsletters oder nach Zweckfortfall aus der
            Newsletterverteilerliste gelöscht. Wir behalten uns vor,
            E-Mail-Adressen aus unserem Newsletterverteiler nach eigenem
            Ermessen im Rahmen unseres berechtigten Interesses nach Art. 6 Abs.
            1 lit. f DSGVO zu löschen oder zu sperren.
            <br />
            <br />
            Daten, die zu anderen Zwecken bei uns gespeichert wurden, bleiben
            hiervon unberührt.
            <br />
            Nach Ihrer Austragung aus der Newsletterverteilerliste wird Ihre
            E-Mail-Adresse bei uns bzw. dem Newsletterdiensteanbieter ggf. in
            einer Blacklist gespeichert, sofern dies zur Verhinderung künftiger
            Mailings erforderlich ist. Die Daten aus der Blacklist werden nur
            für diesen Zweck verwendet und nicht mit anderen Daten
            zusammengeführt. Dies dient sowohl Ihrem Interesse als auch unserem
            Interesse an der Einhaltung der gesetzlichen Vorgaben beim Versand
            von Newslettern (berechtigtes Interesse im Sinne des Art. 6 Abs. 1
            lit. f DSGVO). Die Speicherung in der Blacklist ist zeitlich nicht
            befristet. Sie können der Speicherung widersprechen, sofern Ihre
            Interessen unser berechtigtes Interesse überwiegen.
          </Typography>

          {/* 8. Audio- und Videokonferenzen */}
          <Typography variant="h5" className={classes.bold}>
            8. Audio- und Videokonferenzen
          </Typography>

          <Typography variant="h6" className={classes.bold}>
            Datenverarbeitung
          </Typography>
          <Typography variant="body1" className={classes.marginBottom}>
            Für die Kommunikation mit unseren Kunden setzen wir unter anderen
            Online-Konferenz-Tools ein. Die im Einzelnen von uns genutzten Tools
            sind unten aufgelistet. Wenn Sie mit uns per Video- oder
            Audiokonferenz via Internet kommunizieren, werden Ihre
            personenbezogenen Daten von uns und dem Anbieter des jeweiligen
            Konferenz-Tools erfasst und verarbeitet.
            <br />
            Die Konferenz-Tools erfassen dabei alle Daten, die Sie zur Nutzung
            der Tools bereitstellen/einsetzen (E-Mail-Adresse und/oder Ihre
            Telefonnummer). Ferner verarbeiten die Konferenz-Tools die Dauer der
            Konferenz, Beginn und Ende (Zeit) der Teilnahme an der Konferenz,
            Anzahl der Teilnehmer und sonstige „Kontextinformationen“ im
            Zusammenhang mit dem Kommunikationsvorgang (Metadaten).
            <br />
            Des Weiteren verarbeitet der Anbieter des Tools alle technischen
            Daten, die zur Abwicklung der Online-Kommunikation erforderlich
            sind. Dies umfasst insbesondere IP-Adressen, MAC-Adressen,
            Geräte-IDs, Gerätetyp, Betriebssystemtyp und -version,
            Client-Version, Kameratyp, Mikrofon oder Lautsprecher sowie die Art
            der Verbindung.
            <br />
            Sofern innerhalb des Tools Inhalte ausgetauscht, hochgeladen oder in
            sonstiger Weise bereitgestellt werden, werden diese ebenfalls auf
            den Servern der Tool-Anbieter gespeichert. Zu solchen Inhalten
            zählen insbesondere Cloud-Aufzeichnungen, Chat-/ Sofortnachrichten,
            Voicemails hochgeladene Fotos und Videos, Dateien, Whiteboards und
            andere Informationen, die während der Nutzung des Dienstes geteilt
            werden.
            <br />
            Bitte beachten Sie, dass wir nicht vollumfänglich Einfluss auf die
            Datenverarbeitungsvorgänge der verwendeten Tools haben. Unsere
            Möglichkeiten richten sich maßgeblich nach der Unternehmenspolitik
            des jeweiligen Anbieters. Weitere Hinweise zur Datenverarbeitung
            durch die Konferenztools entnehmen Sie den Datenschutzerklärungen
            der jeweils eingesetzten Tools, die wir unter diesem Text aufgeführt
            haben.
          </Typography>

          <Typography variant="h6" className={classes.bold}>
            Zweck und Rechtsgrundlagen
          </Typography>
          <Typography variant="body1" className={classes.marginBottom}>
            Die Konferenz-Tools werden genutzt, um mit angehenden oder
            bestehenden Vertragspartnern zu kommunizieren oder bestimmte
            Leistungen gegenüber unseren Kunden anzubieten (Art. 6 Abs. 1 lit. b
            DSGVO). Des Weiteren dient der Einsatz der Tools der allgemeinen
            Vereinfachung und Beschleunigung der Kommunikation mit uns bzw.
            unserem Unternehmen (berechtigtes Interesse im Sinne von Art. 6 Abs.
            1 lit. f DSGVO). Soweit eine Einwilligung abgefragt wurde, erfolgt
            der Einsatz der betreffenden Tools auf Grundlage dieser
            Einwilligung; die Einwilligung ist jederzeit mit Wirkung für die
            Zukunft widerrufbar.
          </Typography>

          <Typography variant="h6" className={classes.bold}>
            Speicherdauer
          </Typography>
          <Typography variant="body1" className={classes.marginBottom}>
            Die unmittelbar von uns über die Video- und Konferenz-Tools
            erfassten Daten werden von unseren Systemen gelöscht, sobald Sie uns
            zur Löschung auffordern, Ihre Einwilligung zur Speicherung
            widerrufen oder der Zweck für die Datenspeicherung entfällt.
            Gespeicherte Cookies verbleiben auf Ihrem Endgerät, bis Sie sie
            löschen. Zwingende gesetzliche Aufbewahrungsfristen bleiben
            unberührt.
            <br />
            Auf die Speicherdauer Ihrer Daten, die von den Betreibern der
            Konferenz-Tools zu eigenen Zwecken gespeichert werden, haben wir
            keinen Einfluss. Für Einzelheiten dazu informieren Sie sich bitte
            direkt bei den Betreibern der Konferenz-Tools.
          </Typography>

          <Typography variant="h6" className={classes.bold}>
            Eingesetzte Konferenz-Tools
          </Typography>
          <Typography variant="body1" className={classes.marginBottom}>
            Wir setzen folgende Konferenz-Tools ein:
          </Typography>

          <Typography variant="h6" className={classes.bold}>
            Microsoft Teams
          </Typography>
          <Typography variant="body1" className={classes.marginBottom}>
            Wir nutzen Microsoft Teams. Anbieter ist die Microsoft Ireland
            Operations Limited, One Microsoft Place, South County Business Park,
            Leopardstown, Dublin 18, Irland. Details zur Datenverarbeitung
            entnehmen Sie der Datenschutzerklärung von Microsoft Teams:{" "}
            <Link
              href="https://privacy.microsoft.com/de-de/privacystatement"
              external
              className={classes.link}
            >
              https://privacy.microsoft.com/de-de/privacystatement
            </Link>
            .
            <br />
            <br />
            Das Unternehmen verfügt über eine Zertifizierung nach dem „EU-US
            Data Privacy Framework“ (DPF). Der DPF ist ein Übereinkommen
            zwischen der Europäischen Union und den USA, der die Einhaltung
            europäischer Datenschutzstandards bei Datenverarbeitungen in den USA
            gewährleisten soll. Jedes nach dem DPF zertifizierte Unternehmen
            verpflichtet sich, diese Datenschutzstandards einzuhalten. Weitere
            Informationen hierzu erhalten Sie vom Anbieter unter folgendem Link:{" "}
            <Link
              href="https://www.dataprivacyframework.gov/participant/6474"
              external
              className={classes.link}
            >
              https://www.dataprivacyframework.gov/participant/6474
            </Link>
            .
            <br />
            <br />
            Auftragsverarbeitung
            <br />
            Wir haben einen Vertrag über Auftragsverarbeitung (AVV) zur Nutzung
            des oben genannten Dienstes geschlossen. Hierbei handelt es sich um
            einen datenschutzrechtlich vorgeschriebenen Vertrag, der
            gewährleistet, dass dieser die personenbezogenen Daten unserer
            Websitebesucher nur nach unseren Weisungen und unter Einhaltung der
            DSGVO verarbeitet.
          </Typography>

          <Typography variant="h6" className={classes.bold}>
            Google Meet
          </Typography>
          <Typography variant="body1" className={classes.marginBottom}>
            Wir nutzen Google Meet. Anbieter ist die Google Ireland Limited,
            Gordon House, Barrow Street, Dublin 4, Irland. Details zur
            Datenverarbeitung entnehmen Sie der Datenschutzerklärung von Google:{" "}
            <Link
              href="https://policies.google.com/privacy?hl=de"
              external
              className={classes.link}
            >
              https://policies.google.com/privacy?hl=de
            </Link>
            .
            <br />
            <br />
            Das Unternehmen verfügt über eine Zertifizierung nach dem „EU-US
            Data Privacy Framework“ (DPF). Der DPF ist ein Übereinkommen
            zwischen der Europäischen Union und den USA, der die Einhaltung
            europäischer Datenschutzstandards bei Datenverarbeitungen in den USA
            gewährleisten soll. Jedes nach dem DPF zertifizierte Unternehmen
            verpflichtet sich, diese Datenschutzstandards einzuhalten. Weitere
            Informationen hierzu erhalten Sie vom Anbieter unter folgendem Link:{" "}
            <Link
              href="https://www.dataprivacyframework.gov/participant/5780"
              external
              className={classes.link}
            >
              https://www.dataprivacyframework.gov/participant/5780
            </Link>
            .
            <br />
            <br />
            Auftragsverarbeitung
            <br />
            Wir haben einen Vertrag über Auftragsverarbeitung (AVV) zur Nutzung
            des oben genannten Dienstes geschlossen. Hierbei handelt es sich um
            einen datenschutzrechtlich vorgeschriebenen Vertrag, der
            gewährleistet, dass dieser die personenbezogenen Daten unserer
            Websitebesucher nur nach unseren Weisungen und unter Einhaltung der
            DSGVO verarbeitet.
          </Typography>

          {/* 9. Eigene Dienste */}
          <Typography variant="h5" className={classes.bold}>
            9. Eigene Dienste
          </Typography>

          <Typography variant="h6" className={classes.bold}>
            Umgang mit Bewerberdaten
          </Typography>
          <Typography variant="body1" className={classes.marginBottom}>
            Wir bieten Ihnen die Möglichkeit, sich bei uns zu bewerben (z. B.
            per E-Mail, postalisch oder via Online-Bewerberformular). Im
            Folgenden informieren wir Sie über Umfang, Zweck und Verwendung
            Ihrer im Rahmen des Bewerbungsprozesses erhobenen personenbezogenen
            Daten. Wir versichern, dass die Erhebung, Verarbeitung und Nutzung
            Ihrer Daten in Übereinstimmung mit geltendem Datenschutzrecht und
            allen weiteren gesetzlichen Bestimmungen erfolgt und Ihre Daten
            streng vertraulich behandelt werden.
          </Typography>

          <Typography variant="h6" className={classes.bold}>
            Umfang und Zweck der Datenerhebung
          </Typography>
          <Typography variant="body1" className={classes.marginBottom}>
            Wenn Sie uns eine Bewerbung zukommen lassen, verarbeiten wir Ihre
            damit verbundenen personenbezogenen Daten (z. B. Kontakt- und
            Kommunikationsdaten, Bewerbungsunterlagen, Notizen im Rahmen von
            Bewerbungsgesprächen etc.), soweit dies zur Entscheidung über die
            Begründung eines Beschäftigungsverhältnisses erforderlich ist.
            Rechtsgrundlage hierfür ist § 26 BDSG nach deutschem Recht
            (Anbahnung eines Beschäftigungsverhältnisses), Art. 6 Abs. 1 lit. b
            DSGVO (allgemeine Vertragsanbahnung) und – sofern Sie eine
            Einwilligung erteilt haben – Art. 6 Abs. 1 lit. a DSGVO. Die
            Einwilligung ist jederzeit widerrufbar. Ihre personenbezogenen Daten
            werden innerhalb unseres Unternehmens ausschließlich an Personen
            weitergegeben, die an der Bearbeitung Ihrer Bewerbung beteiligt
            sind.
            <br />
            Sofern die Bewerbung erfolgreich ist, werden die von Ihnen
            eingereichten Daten auf Grundlage von § 26 BDSG und Art. 6 Abs. 1
            lit. b DSGVO zum Zwecke der Durchführung des
            Beschäftigungsverhältnisses in unseren Datenverarbeitungssystemen
            gespeichert.
          </Typography>

          <Typography variant="h6" className={classes.bold}>
            Aufbewahrungsdauer der Daten
          </Typography>
          <Typography variant="body1" className={classes.marginBottom}>
            Sofern wir Ihnen kein Stellenangebot machen können, Sie ein
            Stellenangebot ablehnen oder Ihre Bewerbung zurückziehen, behalten
            wir uns das Recht vor, die von Ihnen übermittelten Daten auf
            Grundlage unserer berechtigten Interessen (Art. 6 Abs. 1 lit. f
            DSGVO) bis zu 6 Monate ab der Beendigung des Bewerbungsverfahrens
            (Ablehnung oder Zurückziehung der Bewerbung) bei uns aufzubewahren.
            Anschließend werden die Daten gelöscht und die physischen
            Bewerbungsunterlagen vernichtet. Die Aufbewahrung dient insbesondere
            Nachweiszwecken im Falle eines Rechtsstreits. Sofern ersichtlich
            ist, dass die Daten nach Ablauf der 6-Monatsfrist erforderlich sein
            werden (z. B. aufgrund eines drohenden oder anhängigen
            Rechtsstreits), findet eine Löschung erst statt, wenn der Zweck für
            die weitergehende Aufbewahrung entfällt.
            <br />
            Eine längere Aufbewahrung kann außerdem stattfinden, wenn Sie eine
            entsprechende Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) erteilt
            haben oder wenn gesetzliche Aufbewahrungspflichten der Löschung
            entgegenstehen.
          </Typography>

          {/* 10. Kundeninformationen */}
          <Typography variant="h5" className={classes.bold}>
            10. Kundeninformationen
          </Typography>
          <Typography variant="body1" className={classes.marginBottom}>
            Zur Unterstützung interner Geschäftsprozesse und Kundenprojekte
            können KI-gestützte Systeme eingesetzt werden. Dabei werden
            ausschließlich datenschutzkonforme Dienste verwendet, bei denen
            keine Verarbeitung zu Trainingszwecken erfolgt. Personenbezogene
            Daten werden nur verarbeitet, sofern hierfür eine
            datenschutzrechtliche Grundlage besteht.
          </Typography>
        </Grid>

        <Grid item xs={2} />
      </Grid>

      <Footer />
    </div>
  );
}

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
